import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppSettings } from './../../app.settings';
import { UiService } from '../../services/ui.service';
import { ConfirmationService, MenuItem, Message, SelectItem } from 'primeng/api';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { StorageService } from './../../services/storage.service';
import { UserCommonService } from './../../services/user-common.service';
import { NotificationsService } from './../../services/notifications.service';
import { EditProfileComponent } from './../edit-profile/edit-profile.component';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { environment } from 'environments/environment';
import { PageHeaderService, PageHeaderState } from '../../services/page-header.service';
import { UnsavedChangesService } from '../../services/unsaved-changes.service';

const VIEW_EVENT_DETAILS_PATH = 'events/event-details';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(EditProfileComponent) editPro: EditProfileComponent;
  notificationInterval;
  userFullName: string;
  items: MenuItem[];
  message: Message[] = [];
  eventListOptions: any = [];
  eventData: any = [];
  eventListOptions1: SelectItem[];
  profileUrl = AppSettings.DEFAULT_PROFILE_IMAGE_URL;
  changePasswordPopup = false;
  editProfilePopup = false;
  subscription: Subscription;
  pageHeaderSubscription: Subscription;
  pageHeaderState: PageHeaderState;
  myDate = new Date(1496314866000);
  myDateLong = 1496314866000;
  minuts = 240;
  notifications: any = [];
  unReadNotificatonsCount = 0;
  params: any = '';
  limit = 5;
  offset = 0;
  selectedEvent;
  selectedTimeZone;
  showMoreOff = true;
  hasShowNotificationBar = false;
  showEventChangeDialog = false;
  pendingEventValue: string | null = null;
  notificationLabel;
  noNotificationFoundLabel;
  uploadedImagePath = AppSettings.GET_FILE_GRID_IMG_URL;
  imageLoadStatus: { [key: string]: boolean } = {};
  defaultImagePath = AppSettings.DEFAULT_EVENT_IMAGE_URL;

  constructor(
    private uiService: UiService,
    private userCommandService: UserCommonService,
    private commonBindingDataService: CommonBindingDataService,
    private storageService: StorageService,
    private notificationsService: NotificationsService,
    private pageHeaderService: PageHeaderService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    private unsavedChangesService: UnsavedChangesService) {
  }

  ngOnInit() {
    this.notificationLabel = this.commonBindingDataService.getLabel('label_notifications');
    this.noNotificationFoundLabel = this.commonBindingDataService.getLabel('label_no_notification_found');

    this.items = [
      {
        label: 'Edit Profile', icon: 'fa fa-user-circle-o', command: (event) => {
          this.editProfile();
        }
      },
      {
        label: 'Change password', icon: 'fa  fa-key', command: (event) => {
          this.changePassword();
        }
      },
      {
        label: 'Logout', icon: 'fa fa-sign-out', command: (event) => {
          this.doSignOut();
        }
      }
    ];

    const userObj: any = this.storageService.getItemFromSessionStorage(AppSettings.USER_DETAILS);
    if (userObj !== undefined && userObj !== null) {
      this.userFullName = userObj.firstName + ' ' + userObj.lastName;
      if (userObj.userDetails !== undefined && userObj.userDetails !== null
        && userObj.userDetails.profileImage !== null && userObj.userDetails.profileImage !== '') {
        this.profileUrl = AppSettings.GET_FILE_THUMB_URL + userObj.userDetails.profileImage;
      } else {
        this.profileUrl = AppSettings.DEFAULT_PROFILE_IMAGE_URL;
      }
    }

    this.subscription = this.uiService.profileUpdatedEvent
      .subscribe((state: string) => {
        this.updateProfileContent();
      });

    this.pageHeaderSubscription = this.pageHeaderService.pageHeader$
      .subscribe((state: PageHeaderState) => {
        this.pageHeaderState = {
          ...state,
          breadcrumbs: [...(state.breadcrumbs || [])]
        };
        // and avoid deferred Promise updates that can apply stale breadcrumbs.
        this.cdr.detectChanges();
      });

    this.getEventList();
  }

  getEventList() {
    this.commonBindingDataService.getEventList().subscribe((results) => {
      this.eventListOptions = [];
      this.eventData = results?.eventList || [];
      for (let event = 0; event < this.eventData.length; event++) {
        this.eventListOptions.push({
          label: this.eventData[event].eventName,
          imageId: this.eventData[event].eventImageId,
          value: this.eventData[event].id,
          timezone: this.eventData[event].timezone
        });
      }
      this.storageService.setSessionStorage('storeEventList', this.eventListOptions);
      this.applyResolvedEvent();
      this.commonBindingDataService.events.next(this.eventListOptions);
      if (this.selectedEvent) {
        this.commonBindingDataService.getVehicleType(this.selectedEvent).subscribe(vehicleTypeData => {
          this.storageService.setSessionStorage(AppSettings.VEHICLE_TYPE_DATA, vehicleTypeData);
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        });
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  private applyResolvedEvent(): void {
    const savedEventId = this.getSavedEventIdForLoggedInUser();
    const eventToSelect = this.findEventInCurrentList(savedEventId) || this.eventData[0] || null;
    this.persistSelectedEvent(eventToSelect);
  }

  private getSavedEventIdForLoggedInUser(): string | null {
    const loggedInUserKey = this.getLoggedInUserKey();
    if (loggedInUserKey) {
      const savedByUser = this.getLastSelectedEventMap()[loggedInUserKey];
      if (savedByUser?.eventId) {
        return String(savedByUser.eventId);
      }
    }

    const sessionEventId = this.storageService.getItemFromSessionStorage('storedEventId');
    return sessionEventId ? String(sessionEventId) : null;
  }

  private findEventInCurrentList(eventId: string | null): any | null {
    if (!eventId || !Array.isArray(this.eventData)) {
      return null;
    }
    return this.eventData.find((event: any) => String(event?.id) === String(eventId)) || null;
  }

  private persistSelectedEvent(eventObj: any | null): void {
    if (!eventObj) {
      this.selectedEvent = '';
      this.selectedTimeZone = this.commonBindingDataService.getTenantConfigValue(AppSettings.DEFAULT_TIMEZONE);
      this.storageService.setSessionStorage('storedTimezone', this.selectedTimeZone);
      return;
    }

    this.selectedEvent = eventObj.id;
    this.selectedTimeZone = eventObj.timezone;
    this.storageService.setSessionStorage('storedEventId', eventObj.id);
    this.storageService.setSessionStorage('selectedEvent', eventObj);
    this.storageService.setSessionStorage('storedTimezone', this.selectedTimeZone);
    this.saveEventForLoggedInUser(eventObj);
    this.commonBindingDataService.changedEventId = this.selectedEvent;
    this.commonBindingDataService.eventId.next(this.selectedEvent);
  }

  private getLastSelectedEventMap(): Record<string, { eventId: string; timezone?: string }> {
    const stored: any = this.storageService.getItem(AppSettings.LAST_SELECTED_EVENT);
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
      return {};
    }

    const keys = Object.keys(stored);
    const isUserEventMap = keys.length > 0 && keys.every((key) => {
      const value = stored[key];
      return value && typeof value === 'object' && (value as any).eventId;
    });
    if (isUserEventMap) {
      return stored;
    }
    return {};
  }

  private saveEventForLoggedInUser(eventObj: any): void {
    const loggedInUserKey = this.getLoggedInUserKey();
    if (!loggedInUserKey || !eventObj?.id) {
      return;
    }
    const lastSelectedByUser = { ...this.getLastSelectedEventMap() };
    lastSelectedByUser[loggedInUserKey] = {
      eventId: eventObj.id,
      timezone: eventObj.timezone
    };
    this.storageService.setItem(AppSettings.LAST_SELECTED_EVENT, lastSelectedByUser);
  }

  private getLoggedInUserKey(): string {
    const user: any = this.storageService.getItemFromSessionStorage(AppSettings.USER_DETAILS);
    const userKey = user?.id ?? user?.userId ?? user?.userDetails?.id;
    return userKey != null && userKey !== '' ? String(userKey) : '';
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImagePath;
  }

  onImageLoad(imageId: string) {
    this.imageLoadStatus[imageId] = true;
  }
  getImageSrc(imageId: string | null): string {
    return imageId ? `${this.uploadedImagePath}${imageId}` : this.defaultImagePath;
  }

  changeFilter(event: any) {
    this.params = '?';
    this.pendingEventValue = event?.value ?? null;

    // Edit Event with unsaved changes: never auto-save; switch only after Discard (EVT-US-04 §46).
    if (this.unsavedChangesService.hasUnsavedChanges()) {
      this.confirmDiscardBeforeEventChange();
      return;
    }

    // View Event Details is read-only: switch in place instead of the portal reload (EVT-US-03 §46).
    if (this.isViewEventDetailsRoute()) {
      this.switchViewEventDetails();
      return;
    }

    this.showEventChangeDialog = true;
  }

  private confirmDiscardBeforeEventChange(): void {
    this.confirmationService.confirm({
      header: this.commonBindingDataService.getLabel('label_discard_changes_question'),
      message: this.commonBindingDataService.getLabel('msg_discard_changes_unsaved'),
      acceptLabel: this.commonBindingDataService.getLabel('label_discard_changes'),
      rejectLabel: this.commonBindingDataService.getLabel('label_continue_editing'),
      accept: () => {
        this.unsavedChangesService.discardChanges();
        this.onConfirmEventChange();
      },
      reject: () => this.onCancelEventChange()
    });
  }

  /** `/events/event-details` itself; its Settings child keeps the normal portal reload. */
  private isViewEventDetailsRoute(): boolean {
    const primary = this.router.parseUrl(this.router.url).root.children['primary'];
    const path = primary ? primary.segments.map((segment) => segment.path).join('/') : '';
    return path === VIEW_EVENT_DETAILS_PATH;
  }

  private switchViewEventDetails(): void {
    const selectedEventObj = this.findEventInCurrentList(this.pendingEventValue);
    this.pendingEventValue = null;

    if (!selectedEventObj) {
      return;
    }

    this.persistSelectedEvent(selectedEventObj);

    const currentQueryParams = this.router.parseUrl(this.router.url).queryParams;
    this.router.navigate(['/' + VIEW_EVENT_DETAILS_PATH], {
      queryParams: { ...currentQueryParams, id: selectedEventObj.id }
    });
  }

  onConfirmEventChange() {
    const pendingValue = this.pendingEventValue;
    this.pendingEventValue = null;
    this.showEventChangeDialog = false;

    const selectedEventObj = this.findEventInCurrentList(pendingValue);
    if (selectedEventObj) {
      this.persistSelectedEvent(selectedEventObj);
    }

    // Hash routing: must navigate via Angular router (or #/url), not window.location pathname.
    const navigateUrl = this.getFirstAccessGroupDisplayUrl();
    const targetUrl = this.normalizeAppRoute(navigateUrl);
    if (targetUrl) {
      this.router.navigateByUrl(targetUrl).then(() => {
        window.location.reload();
      }).catch(() => {
        window.location.reload();
      });
    } else {
      window.location.reload();
    }
  }

  onCancelEventChange() {
    if (this.pendingEventValue !== null) {
      const savedEvent = this.findEventInCurrentList(this.getSavedEventIdForLoggedInUser());
      this.selectedEvent = savedEvent?.id || this.eventListOptions[0]?.value || '';
    }
    this.pendingEventValue = null;
    this.showEventChangeDialog = false;
  }

  /**
   * Reads accessGroup stored at login (ACCESS_MENU) and returns 0th item displayUrl.
   * If the group only has children, uses the first submenu displayUrl.
   */
  private getFirstAccessGroupDisplayUrl(): string | null {
    const accessGroup: any[] = this.storageService.getItemFromSessionStorage(AppSettings.ACCESS_MENU);
    if (!Array.isArray(accessGroup) || !accessGroup.length) {
      return null;
    }

    const firstAccess = accessGroup[0];
    if (!firstAccess || firstAccess.accessGroupCode === 'COMMON') {
      const fallback = accessGroup.find(item => item?.accessGroupCode !== 'COMMON');
      return this.resolveAccessDisplayUrl(fallback);
    }
    return this.resolveAccessDisplayUrl(firstAccess);
  }

  private resolveAccessDisplayUrl(access: any): string | null {
    if (!access) {
      return null;
    }
    if (access.displayUrl) {
      this.storageService.setSessionStorage('selectedMenu', access.accessGroupCode);
      this.storageService.setSessionStorage('dashboard', [access.displayUrl]);
      return access.displayUrl;
    }
    const firstSubMenu = (access.subMenuList || []).find((sub: any) => !!sub?.displayUrl);
    if (firstSubMenu?.displayUrl) {
      this.storageService.setSessionStorage('selectedMenu', firstSubMenu.accessGroupCode || access.accessGroupCode);
      this.storageService.setSessionStorage('dashboard', [firstSubMenu.displayUrl]);
      return firstSubMenu.displayUrl;
    }
    return null;
  }

  private normalizeAppRoute(url: string | null): string | null {
    if (!url || typeof url !== 'string') {
      return null;
    }
    const trimmed = url.trim();
    if (!trimmed || trimmed === '/' || trimmed === '#/' || trimmed.toLowerCase() === '/signin') {
      return null;
    }
    const withoutHash = trimmed.replace(/^#/, '');
    return withoutHash.startsWith('/') ? withoutHash : `/${withoutHash}`;
  }

  getNotificationListAndToggle(event) {
    this.unReadNotificatonsCount = 0;
    this.limit = 10;
    this.offset = 0;
    this.notifications = [];
    this.getNotificationList();
    this.hasShowNotificationBar = true;
  }

  getNotificationList() {
    this.notificationsService.getDetails(this.limit, this.offset).subscribe(notification => {
      if (notification.data.length > 0) {
        this.offset = this.offset + notification.limit;
        this.notifications = [...this.notifications, ...notification.data];
      } else {
        this.showMessage('Success', this.noNotificationFoundLabel);
      }
    });
  }

  loadMoreNotification() {
    this.getNotificationList();
  }

  onSideMenuClick(event: any) {
    event.preventDefault();
    this.uiService.toggleSidebar();
  }

  onPageHeaderBack() {
    if (this.pageHeaderState && this.pageHeaderState.onBack) {
      this.pageHeaderState.onBack();
    }
  }

  doSignOut() {
    this.userCommandService.signOut().subscribe(results => {
      if (results) {
        const userType = this.storageService.getItemFromSessionStorage('loggedInUserType');
        if (userType == 'adminUser') {
          this.notificationsService.stopFetchingNotifications();
          this.notificationsService.canFetchNotification = false;
          window.location.href = environment.domainURL
          this.storageService.removeAll();
          this.storageService.clearSessionStorage();
          window.location.reload();
        }

        if (userType == 'ssoUser') {
          setTimeout(() => {
            this.storageService.removeAll();
            this.storageService.clearSessionStorage();
            this.notificationsService.stopFetchingNotifications();
            this.notificationsService.canFetchNotification = false;
            window.location.href = `${AppSettings.BASE_URL}/${AppSettings.TENANT}/saml/ssologout`
            window.location.reload();
          }, 3000);
        }
      }
    }, (error) => {
      this.showMessage('Error', error.general[0].message);
    });
  }

  updateProfileContent() {
    this.userCommandService.getUserProfile().subscribe(results => {
      this.storageService.setSessionStorage(AppSettings.USER_DETAILS, results);
      AppSettings.USER = results;
      this.userFullName = results.firstName + ' ' + results.lastName;
      if (results.userDetails !== undefined && results.userDetails !== null && results.userDetails.profileImage !== null) {
        this.profileUrl = AppSettings.GET_FILE_THUMB_URL + results.userDetails.profileImage;
      }
    }, (error) => {
      this.showMessage('Error', error.general[0].message);
    });
  }

  changePassword() {
    this.changePasswordPopup = true;
  }

  editProfile() {
    this.editProfilePopup = true;
    this.editPro.setData();
  }

  onCancelEditProfile(event: any) {
    this.editProfilePopup = !this.editProfilePopup;
  }

  onCancelChangePassword(event: any) {
    this.changePasswordPopup = !this.changePasswordPopup;
  }

  ngOnDestroy() {
    this.notificationsService.stopFetchingNotifications();
    this.subscription.unsubscribe();
    this.pageHeaderSubscription.unsubscribe();
  }

  showMessage(severity, message) {
    this.message = [];
    this.message.push({ severity: severity.toLowerCase(), summary: severity, detail: message });
  }
}